import { AddressField } from 'constants/loanApplication';

import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const addressFieldsToPasteInConfig = [AddressField.STREET, AddressField.UNIT, AddressField.CITY];

const formFields = [
  ...addressFormFields.reduce((acc, addressField) => {
    if (addressFieldsToPasteInConfig.includes(addressField.name)) {
      const formattedAddressField =
        addressField.name === AddressField.UNIT
          ? {
              ...addressField,
              name: AddressField.SUITE,
              label: 'Suite',
            }
          : addressField;

      acc.push(formattedAddressField);
    }

    return acc;
  }, []),
  {
    name: 'contactTypeId',
    label: 'Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyName',
    label: 'Company Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'phoneNumber',
    label: 'Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'phoneNumberExtension',
    label: 'Phone Number Extension',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'directLine',
    label: 'Direct Line',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const contactsForm = {
  name: FormNames.CONTACTS,
  label: 'Contacts',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
